import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export default class TicketBar {
  constructor(element) {
    this.ticketBar = element;
	 this.trigger = document.querySelector('.js-ticket-bar-trigger');
	 this.footer = document.querySelector('.js-footer');
    this.init();
  }

  init() {
	// Show the ticket bar
	ScrollTrigger.create({
		trigger: this.trigger,
		start: "bottom top",
		onEnter: () => {
			this.ticketBar.classList.remove('is-hidden');
		},
		onLeaveBack: () => {
			this.ticketBar.classList.add('is-hidden');
		}
	});

	// Hide the ticket bar
	ScrollTrigger.create({
		trigger: this.footer,
		start: "top bottom",
		onEnter: () => {
			this.ticketBar.classList.add('is-hidden');
		},
		onLeaveBack: () => {
			this.ticketBar.classList.remove('is-hidden');
		}
	});
  }
}
